import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=67a1911e&"
import script from "./Bank.vue?vue&type=script&lang=ts&"
export * from "./Bank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a1911e')) {
      api.createRecord('67a1911e', component.options)
    } else {
      api.reload('67a1911e', component.options)
    }
    module.hot.accept("./Bank.vue?vue&type=template&id=67a1911e&", function () {
      api.rerender('67a1911e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/Bank.vue"
export default component.exports